/**
 * Use this directive to display multiple elements in one cell in the row definitions of our list.
 *
 * @params {entries=} array of strings which should be displayed

 * @usage
 * <ix-list-multi-cell entries="row.users"></ix-list-multi-cell>
 *
 */
angular.module('impactx.list').directive('ixListMultiCell', function() {
    return {
        restrict: 'E',
        scope: true,
        replace: true,
        bindToController: {
            entries: "=",
            firstEntryTooltip: "=?",
            showAllInTooltip: "=?"
        },
        controller: 'MultiCellCtrl',
        controllerAs: 'multiCellCtrl',
        templateUrl: 'shared/list/templates/listmulticell.tmpl.html'
    }
});